module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"nbVisitDuringWorks":"Nombre de Visites Pendant Travaux (VPT non conformes)","nbVEVisits":"Nombre de Visites d\u0027Entretien","previousYear":"Année n-1","currentYear":"Année en cours","nbCCRainyProjects":"Nombre de conformités pluviales (VPT conformes)","nbCCOnly":"Nombre de contrôle de conformité"}}')
  delete Component.options._Ctor
}
